"use client";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useContext } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = "a";
export function WebLink(props) {
    const { url, className, ...rest } = props;
    const [state, setState] = React.useState({
        settled: false,
        metadata: undefined
    });
    const { unfurl = defaultUnfurl } = useContext().blocks?.WebLink ?? {};
    React.useEffect(()=>{
        unfurl(url).then((metadata)=>{
            setState({
                settled: true,
                metadata: metadata
            });
        }, ()=>{
            setState({
                settled: true,
                metadata: undefined
            });
        });
    }, [
        unfurl,
        url
    ]);
    const metadata = state.metadata;
    const image = metadata?.open_graph?.images?.[0]?.url;
    const rootStyleProps = stylex.props(layoutStyles.block, styles.root);
    return <Root data-timvir-b-weblink href={url} target="_blank" rel="noopener noreferrer" {...rest} {...rootStyleProps} className={cx(!state.settled && "timvir-unsettled", className, rootStyleProps.className)} style={{
        ...rootStyleProps.style,
        ...rest.style
    }}>
      <div className="x1fvrxw4 xhkrif2 xeuugli">
        <div className="x1cdhzux xuxw1ft xb3r6kr xlyipyv xjwf9q1 xzueoph">{metadata?.open_graph?.title ?? metadata?.title ?? <>&nbsp;</>}</div>
        <div className="xboafo0 x1vbrtjm xvgvpxu x1ehw58o xb3r6kr">{metadata?.open_graph?.description ?? metadata?.description}</div>
        <div className="x14vqqas x78zum5 xboafo0 xl2ypbo x1cdhzux xuxw1ft xb3r6kr xlyipyv">
          <img className="xcdlrvm x1l36t39 xgomdpo x15ku74s" style={{
        opacity: metadata?.favicon ? 1 : 0
    }} src={metadata?.favicon} alt=""/>
          <div>{metadata ? url : null}</div>
        </div>
      </div>
      {image && <div className="x15lv9n0 x1n2onr6 xfb3i0g">
          <img className="x1lliihq xl1xv1r x1p4ba9y xh8yej3 x5yr21d x10l6tqk x13vifvy xu96u03" src={image} alt=""/>
        </div>}
    </Root>;
}
const styles = {
    root: {
        kmkexE: "xzhuw26",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "xj7gikm",
        kWkggS: "x1d0dlzq",
        kaIpWk: "x18zih8k",
        k1xSpc: "x78zum5",
        kkrTdU: "x1ypdohk",
        kybGjl: "x1hl2dhg",
        kaVNsj: "x49kzi4",
        kGzVvX: "x1dc5b4e",
        kSVDLA: "x13m658e",
        kSReZ0: "x1bx2y69",
        $$css: true
    }
};
async function defaultUnfurl(url) {
    return fetch(`https://timvir.dev/api/unfurl?url=${encodeURIComponent(url)}`).then((res)=>res.json());
}
